import Customer from "./Customer";

export { Customer };
